const $ = jQuery;

export default () => {
  $('#responsiveTabs').responsiveTabs({
    startCollapsed: false,
    setHash: true
  });
};
